var gql = require("graphql-tag");

const TARIFFS_BEST_HOUSE_QUERY = gql`
    query TariffsAddressBest(
        $houseId: Int!
        $filter: String
        $with_default: Int!
        $region_url: String
    ) {
        tariffsBestByHouse(
            house_id: $houseId
            filter: $filter
            with_default: $with_default
            region_url: $region_url
        ) {
            lowCost {
                id
                name
                displayPrice
                provider {
                    id
                    name
                }
            }
            highSpeed {
                id
                name
                displayPrice
                provider {
                    id
                    name
                }
                internet {
                    speed_in
                }
            }
        }
    }
`;

export default TARIFFS_BEST_HOUSE_QUERY;
